module.exports = __webpack_public_path__ + "static/media/32.725a1d4a.png";